














import { Component, Vue, Prop } from 'vue-property-decorator';

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;

@Component
export default class SelectTeamMember extends Vue {
  @Prop({required: true}) private memberOptions!: IUserDetailInfo[];
  @Prop({default: ''}) private memberId!: string;
  private filterOwnerOptions: IUserDetailInfo[] = this.memberOptions.map((user) => user);
  private handleOwnerSearch(input: string) {
    this.filterOwnerOptions = this.memberOptions.filter((user) => {
      return user.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
    });
  }
  private handleChange(value: string | string[]) {
    this.$emit('update:memberId', value);
    this.$emit('change', value);
  }
}
